import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ReplaySubject, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { CommonModelService } from '../../../../padu-reporting/capability/common-model.service';
import { SimpleChanges } from '@angular/core';
import { MaintenanceService } from '../../../services/maintenanceService';

interface AddLobData {
  MBO_Segment?: string;
  MBO_Segment_ID?: string;
  Leader_Msid?: string;
  Leader_Name?: string;
  Decom_Target_Year?: any;
  Decom_Target?: any;
  DecomLobID?: string;
  DecomLobName?: string;
  Decom_Bus_Segment?: string;
  parent?: any;
  NewAddedSegment?: string;
}

@Component({
    selector: 'decomLob-add-edit-popup',
    templateUrl: './decomLob-add-edit-popup.component.html',
    styleUrls: ['./decomLob-add-edit-popup.component.css'],
    standalone: false
})

export class DecomLobAddEditPopupComponent implements OnInit {

  initialSelectionSet: boolean = false;
  newMBOSegmentClicked = false;
  @Input() dataSource;
  @Input() decomSelectedEditRow;
  uniqueMBOOwners: any[] = [];
  uniqueMBOSegments: any[] = [];
  MBOTargetYear: number[] = [];
  initialAddLobDataUpdated: any;
  @Input() type;
  @Input() filteredData;
  @Output() respondToApplyEmitter : EventEmitter<any> = new EventEmitter();

  destroy$: ReplaySubject<boolean> = new ReplaySubject(1);

  newMBOSegClicked: boolean = false;
  MBOSegmentData = [];
  segmentSelected: string = '';
  lobNameEntered: string = '';
  selectedSegmentObject: any = null;
  subLobDescription:string = '';
  subLobEntered:string = '';
  LobDescription:string = '';
  private subject: Subject<string> = new Subject();
  inputElement: any;
  selectedArchitects = [];
  selectedDelegates = [];
  users:any = [];
  addMBOSegmentData: any;
  AddLobDataUpdated: AddLobData = {};
  disableEditLob: boolean = true;
  disableAddLob: boolean = true;
  disableEditSubLob: boolean = true;
  @Input() resetpopupData;
  @Input() id : any;
  @ViewChild('inputAddChiefArch') inputAddChiefArch: any;
  @ViewChild('inputAddArchDel') inputAddArchDel: any;
  @ViewChild('inputEditChiefArch') inputEditChiefArch: any;
  @ViewChild('inputEditArchDel') inputEditArchDel: any;
  chiefArchitectEditSubLob: any = [];

  TABLE_CONFIG: any = {
    pageSize: [5, 10, 15],
    pageIndex: 0,
    totalItems: 0,
    selection: false,
    edit: false,
    serverSidePagination: false,
    deleteFeature: true,
    expandable: false,
    TABLE_CLASS : 'scroll-table-container'
  };
  
  
  constructor(
    public dialog : MatDialog,
    private capabilityService: CommonModelService,
    private toastrService: ToastrService,
    public maintenanceService: MaintenanceService
  ) { }

  ngOnInit(): void {
    const thisYear = new Date().getFullYear();
    this.MBOTargetYear = [thisYear, thisYear + 1];
    this.getUniqueMBOOwners();
    this.getUniqueMBOSegmentData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataSource']) {
      this.getUniqueMBOOwners();
      this.getUniqueMBOSegmentData();
      this.setSelectedLeaderObject();
    }

    if (changes['decomSelectedEditRow'] && this.decomSelectedEditRow) {
      this.newMBOSegClicked = false;
      // Always reset AddLobDataUpdated to the new row
      this.decomSelectedEditRow = changes['decomSelectedEditRow'].currentValue[0];
      this.getInitialPayload();
      this.initialAddLobDataUpdated = { ...this.AddLobDataUpdated };
      //get existing unique owners and segments
      this.getUniqueMBOOwners();
      this.getUniqueMBOSegmentData(() => {
        if(this.type === 'child') {
          this.setSelectedSegmentChildView();
        }
      });
      //set preselected owner
      this.setSelectedLeaderObject();
      // If you need to update other preselected values, do it here as well
      // For example, update selectedLeaderObject if needed
      //Initial Leader Name
      if (this.AddLobDataUpdated?.Leader_Name) {
        const match = (this.uniqueMBOOwners as any[] || []).find(
          u => u?.Leader_Name === this.AddLobDataUpdated.Leader_Name
        );
        if (match) {
          // bind the object so mat-select has an initial selected option
          // keep Leader_Name string for data, but set a separate selection model
          (this as any).selectedLeaderObject = match;
        }
      }

      //set preselected Segment
      if (this.AddLobDataUpdated?.MBO_Segment) {
        const match = (this.uniqueMBOSegments as any[] || []).find(
          u => u?.MBO_Segment === this.AddLobDataUpdated.MBO_Segment
        );
        if (match) {
          // bind the object so mat-select has an initial selected option
          // keep Leader_Name string for data, but set a separate selection model
          (this as any).selectedSegmentObject = match;
        }
      }

      //set preselected segment for child view
      this.setSelectedSegmentChildView();

      //set preselected Target
      if (this.decomSelectedEditRow && Array.isArray(this.decomSelectedEditRow) && this.decomSelectedEditRow[0]?.Decom_Target) {
        this.AddLobDataUpdated.Decom_Target = this.decomSelectedEditRow[0].Decom_Target;
      } 
    }
  }

  handleSearch(searchObj) {
    const value = searchObj['search'];
    const column = searchObj['column'];
    if (value) {
      this.capabilityService.getLDAPUsers(value).subscribe(dataStream => {
        this.users = [];
          dataStream.forEach(element => {
            this.users.push({ 
              givenName: element.givenName, 
              sn: element.sn,
              mail: element.mail,
              displayName: element.displayName,
              employeeID: element.employeeID,
              MSId: element.cn,
              middleName: element.middleName,
            });
          });
      }, (error) => {
        console.error(error);
       });
    } else {
      column.options = [];
    }
  }

  //When user clicks on Apply button
  onSubmit(type) {
    //if user types existing segment on add
    if(this.newMBOSegClicked && this.uniqueMBOSegments.some(seg=> seg.MBO_Segment === this.AddLobDataUpdated.NewAddedSegment)){
      this.toastrService.error('This segment already exists.', '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
      return;
    }
    if(type === 'parent'){
      this.updateChildRow(type);
    }
    if(type === 'child' && this.newMBOSegClicked === true){
      this.addNewSegment();
    }
    if(type === 'child' && this.newMBOSegClicked === false){
      this.updateChildRow(type);
    }
  }

  toggleSegmentButton(){
    this.newMBOSegClicked = !this.newMBOSegClicked;
    this.AddLobDataUpdated.NewAddedSegment = '';
  }

  getUniqueMBOOwners() {
    const seen = new Set<string>();
    const unique = (this.dataSource || []).filter((item: any) => {
      if (!item?.Leader_Name) return false;
      if (seen.has(item.Leader_Name)) return false;
      seen.add(item.Leader_Name);
      return true;
    }).map((item: any) => ({ Leader_Name: item.Leader_Name }));
    this.uniqueMBOOwners = unique as any;
    this.setSelectedLeaderObject();
  }

  getInitialPayload(){
    if (this.decomSelectedEditRow && Object.keys(this.decomSelectedEditRow).length > 0) {
      // Also update the initial snapshot for comparison
      if(this.type === 'parent') {
        this.AddLobDataUpdated = {
          "MBO_Segment" : this.decomSelectedEditRow.MBO_Segment as string, //
          "MBO_Segment_ID" : this.decomSelectedEditRow.MBO_Segment_ID as string, //
          "Leader_Msid" : this.decomSelectedEditRow.Leader_Msid as string, //
          "Leader_Name" : this.decomSelectedEditRow.Leader_Name as string, //
          "Decom_Target_Year" : this.decomSelectedEditRow.Decom_Target_Year as string, //
          "Decom_Target" : this.decomSelectedEditRow.Decom_Target as string, //
        };
      }
      if(this.type === 'child') {
        this.AddLobDataUpdated = {
          "MBO_Segment" : this.decomSelectedEditRow.parent.MBO_Segment as string, //
          "MBO_Segment_ID" : this.decomSelectedEditRow.parent.MBO_Segment_ID as string, //
          "Leader_Msid" : this.decomSelectedEditRow.parent.Leader_Msid as string, //
          "Leader_Name" : this.decomSelectedEditRow.parent.Leader_Name as string, //
          "Decom_Target_Year" : this.decomSelectedEditRow.parent.Decom_Target_Year as string, //
          "Decom_Target" : this.decomSelectedEditRow.parent.Decom_Target as string, //
          "DecomLobID" : this.decomSelectedEditRow.DecomLobID as string, //
          "DecomLobName" : this.decomSelectedEditRow.DecomLobName as string, //
          "Decom_Bus_Segment" : this.decomSelectedEditRow.Decom_Bus_Segment as string, //
          "NewAddedSegment" : "" as string
        };
      }
    }
  }

  getUniqueMBOSegmentData(callback?: () => void){
    const seen = new Set<string>();
    const unique = (this.dataSource || []).filter((item: any) => {
      if (!item?.MBO_Segment) return false;
      if (seen.has(item.MBO_Segment)) return false;
      seen.add(item.MBO_Segment);
      return true;
    }).map((item: any) => ({ MBO_Segment: item.MBO_Segment }));
    this.uniqueMBOSegments = unique as any;
    if (callback) callback();
    this.setSelectedSegmentChildView()
  }

  isSegmentDetailsUnchanged(): boolean {
    const fields = [
      'MBO_Segment',
      'MBO_Segment_ID',
      'Leader_Msid',
      'Leader_Name',
      'Decom_Target_Year',
      'Decom_Target'
    ];
    return fields.every(key => {
      const a = this.AddLobDataUpdated[key];
      const b = this.initialAddLobDataUpdated[key];
      // Normalize: trim strings, coerce numbers
      if (typeof a === 'string' && typeof b === 'string') {
        return a.trim() === b.trim();
      }
      return a == b; // loose equality for number/string
    });
  }

  isSegmentUnchanged(){
    if(this.AddLobDataUpdated?.MBO_Segment === undefined){
      return true;
    }
      return this.initialAddLobDataUpdated.MBO_Segment === this.AddLobDataUpdated.MBO_Segment; // loose equality for number/string
  }

  updateChildRow(type){
    let payload;
    let segId;

    if(type ==="parent"){
      segId = this.AddLobDataUpdated.MBO_Segment_ID;
      payload = {
        "Leader_Msid": this.AddLobDataUpdated.Leader_Msid,
        "Leader_Name": this.AddLobDataUpdated.Leader_Name,
        "Decom_Target_Year": String(this.AddLobDataUpdated.Decom_Target_Year),
        "Decom_Target": parseInt(this.AddLobDataUpdated.Decom_Target,10)
      }
      const sanitizedPayload = this.sanitizePayload(payload);
      this.maintenanceService.updateDecomLobOwnerTargetTargetYear(segId, sanitizedPayload).subscribe(result => {
        if(result){
            this.closeModalAndRespondWithEmitter(true, 'Update')
          }
      }, (error) => {
          console.error(error);
          this.closeModalAndRespondWithEmitter(false, 'Update')
      });  
    }else{ //child case
      let lobId = this.AddLobDataUpdated.DecomLobID;
      let segment = this.AddLobDataUpdated.MBO_Segment; //destination segment name
      // loop thru this.dataSource to get segId using segment to get destination segId
      if (this.dataSource && segment) {
        const found = this.dataSource.find(item => item.MBO_Segment === segment);
        if (found) {
          segId = found.MBO_Segment_ID;
        }
      }
      payload = {
        "segmentId": segId,
      }
      this.maintenanceService.updateDecomLobSegment(payload, lobId).subscribe(result => {
        if(result){
            this.closeModalAndRespondWithEmitter(true, 'Update')
          }
      }, (error) => {
          console.error(error);
          this.closeModalAndRespondWithEmitter(false, 'Update')
      });  
    }
  }

  addNewSegment(){
    let payload = {
      "MBO_Segment": this.AddLobDataUpdated.NewAddedSegment,
      "Leader_Msid": this.AddLobDataUpdated.Leader_Msid,
      "Leader_Name": this.AddLobDataUpdated.Leader_Name,
      "Decom_Target_Year": String(this.AddLobDataUpdated.Decom_Target_Year),
      "Decom_Target": parseInt(this.AddLobDataUpdated.Decom_Target,10),
      "DecomLobID": this.AddLobDataUpdated.DecomLobID,
      "DecomLobName": this.AddLobDataUpdated.DecomLobName
    };

    payload = this.sanitizePayload(payload);

    this.maintenanceService.addNewDecomLobSegment(payload).subscribe(result => {
        if(result){
          this.closeModalAndRespondWithEmitter(true, 'Add')
        }
      }, (error) => {
        console.error(error);
        this.closeModalAndRespondWithEmitter(false, 'Add')
    });  
  }

  selectedLeaderObject: any = null;
  setSelectedLeaderObject() {
  if (this.AddLobDataUpdated?.Leader_Name && Array.isArray(this.uniqueMBOOwners)) {
    const match = this.uniqueMBOOwners.find(
      u => u?.Leader_Name === this.AddLobDataUpdated.Leader_Name
    );
    if (match) {
      this.selectedLeaderObject = match;
    }
  }
}

closeModalAndRespondWithEmitter(success, type){
  this.respondToApplyEmitter.emit({
    success: success,
    type: type
  }); 
}

sanitizeInput(input: string): string {
  return input.replace(/[^a-zA-Z0-9 _-]/g, '');
}

sanitizePayload(payload: any): any {
  const sanitized = { ...payload };
  Object.keys(sanitized).forEach(key => {
    if (typeof sanitized[key] === 'string') {
      sanitized[key] = this.sanitizeInput(sanitized[key]);
    }
  });
  return sanitized;
}

  disableApplyFromAdd(): boolean {
    if (this.AddLobDataUpdated.NewAddedSegment === undefined || this.AddLobDataUpdated.NewAddedSegment ==='' || this.AddLobDataUpdated.NewAddedSegment === null) {
      return true;
    }
    return false;
  }

  setSelectedSegmentChildView() {
    if (!this.AddLobDataUpdated?.MBO_Segment || !Array.isArray(this.uniqueMBOSegments)) return;
    const match = this.uniqueMBOSegments.find(
      seg => seg.MBO_Segment === this.AddLobDataUpdated.MBO_Segment
    );
    this.selectedSegmentObject = match ?? null;
  }
}
